const customerIdEle = document.querySelector('#customer--id');
const customerId = customerIdEle.value;
const loadMoreButton = document.querySelector('#load-more-quotes');
const _searchFormEleQuotes = document.querySelector('.customer-quotes__search');
// const baseUrl = `https://adh-shopify.herokuapp.com/ext-api/customers`;
const baseUrl = `https://utils.anthomdesignhouse.com/api/ext`;
const shopUrl = `anthomdesignhouse.myshopify.com`;

async function fetchCustomerDraftOrders(customer_id, after, search_string = null) {
  let search_str = search_string;
  if(search_str) {
    if(!(search_str.toString().startsWith('#D') || search_str.toString().startsWith('D'))) {
      search_str = 'D' + search_str;
    }
  }
  const url = `${baseUrl}/${customer_id}/draft-orders?shop=${shopUrl}${after ? '&after=' + after : ''}${search_str ? '&search_string=' + search_str : ''}`;
  const draftOrders = await fetch(url)
  .then(response => response.json());
  // .then(data => data?.draft_orders)
  
  // console.log(draftOrders);

  return draftOrders;
}

async function loadDraftOrdersTable(after = null, search_string = null, refresh = false) {
  const container = document.querySelector('.customer-quotes-history');
  if(!container) return;

  await fetchCustomerDraftOrders(customerId, after, search_string)
  .then(({draft_orders, page_info}) => {
    console.log(draft_orders)
    const markup = generateCustomerDraftOrdersMarkup(draft_orders);

    if(markup && markup.length) {
      if(refresh) {
        container.querySelector('tbody').innerHTML = markup;
      } else {
        container.querySelector('tbody').insertAdjacentHTML('beforeend', markup);
      }
      
      container.classList.remove('hidden');

      if(page_info?.hasNextPage) {
        loadMoreButton.setAttribute('data-after', page_info.endCursor);
        loadMoreButton.removeAttribute('disabled');
      } else {
        loadMoreButton.setAttribute('disabled', true);
      }
    }
  });
}

function generateCustomerDraftOrdersMarkup(draftOrders) {
  if(!draftOrders) return;

  return draftOrders.map((draftOrder) => {
    const createdAt = draftOrder?.createdAt ? new Date(draftOrder?.createdAt) : '';
    const options = { year: 'numeric', month: 'long', day: 'numeric' };

    const createdAtDate = createdAt ? createdAt.toLocaleDateString("en-US", options) : ''; 
    const subtotalPrice = parseFloat(draftOrder?.subtotalPrice).toLocaleString("en-US", { style: "currency", currency: "USD" });
    return `
    <tr class="table__section">
      <td data-label="Quote#">${draftOrder?.name}</td>
      <td data-label="Customer">${draftOrder?.customer?.firstName} ${draftOrder?.customer?.lastName}</td>
      <td data-label="Created Date">${createdAtDate ?? '-'}</td>
      <td data-label="Subtotal"><strong>${subtotalPrice}</strong></td>
      <td>
        <div>
        <a title="Download Quote PDF" class="btn btn--secondary btn--quote-action" target="_blank" href="https://utils.anthomdesignhouse.com/api/quote-pdf/Quote-${draftOrder.name?.replace('#', '')}?id=${draftOrder.id.split('/').pop()}&shop=anthomdesignhouse.myshopify.com">
          <svg class="icon icon-download" enable-background="new 0 0 32 32"  id="download_icon" version="1.1" viewBox="0 0 32 32"  xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Download">
              <path d="M31,22c-0.552,0-1,0.448-1,1v7H2v-7c0-0.552-0.448-1-1-1s-1,0.448-1,1v8c0,0.552,0.448,1,1,1h30   c0.552,0,1-0.448,1-1v-8C32,22.448,31.552,22,31,22z" fill="#121313"/>
              <path d="M15.27,23.707c0.389,0.385,1.04,0.389,1.429,0l6.999-6.9c0.395-0.391,0.394-1.024,0-1.414   c-0.394-0.391-1.034-0.391-1.428,0l-5.275,5.2V1c0-0.552-0.452-1-1.01-1c-0.558,0-1.01,0.448-1.01,1v19.593l-5.275-5.2   c-0.395-0.391-1.034-0.391-1.428,0c-0.395,0.391-0.395,1.024,0,1.414L15.27,23.707z" fill="#121313"/>
            </g>
            <g/>
          </svg>
        </a>
        <edit-draft-order-button title="Edit Quote" class="btn btn--secondary btn--quote-action draft-order-edit" data-draft-id="${draftOrder.id.split('/').pop()}">
          <svg class="icon icon-edit" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
            <g id="edit_icon">
              <rect x="8.793" y="14" width="22" height="2"/>
              <rect x="8.793" y="20" width="22" height="2"/>
              <rect x="8.793" y="26" width="17" height="2"/>
              <rect x="8.793" y="32" width="12" height="2"/>
              <rect x="8.793" y="38" width="12" height="2"/>
              <path d="M38.793,18.586v-10L31.207,1H0.793v48h38V31.414L49.207,21l-6.414-6.414L38.793,18.586z M37.793,22.414L41.379,26l-12,12
                h-3.586v-3.586L37.793,22.414z M31.793,4.414L35.379,8h-3.586V4.414z M36.793,47h-34V3h27v7h7v10.586l-13,13V40h6.414l6.586-6.586
                V47z M42.793,24.586L39.207,21l3.586-3.586L46.379,21L42.793,24.586z"/>
            </g>
          </svg>
        </edit-draft-order-button>
        </div>
      </td>
    </tr>
    `;
  }).join('');
}

function renderCustomerDraftOrders() {
  if(!customerIdEle) return;

  loadDraftOrdersTable();

  if(!loadMoreButton) return;
  loadMoreButton.addEventListener('click', async () => {
    changeLoadingState(loadMoreButton, true);
    const after = loadMoreButton.getAttribute('data-after');

    if(!after) return;

    await loadDraftOrdersTable(after);

    changeLoadingState(loadMoreButton, false);
  });
}

async function clearCart() {
  const cart = await fetch('/cart/clear.js')
  .then(res => res.json());
  // .then(cart => {
  //   const nullHash = {};
  //   for ([key, value] of Object.entries(cart.attributes)) {    
  //       nullHash[key] = null;
  //   }
    
  // });

  console.log('cart', cart)

  if(!cart) return;
  if(!cart?.attributes) return;

  const nullHash = {};
  for ([key, value] of Object.entries(cart.attributes)) {    
      nullHash[key] = null;
  }

  if(!Object.keys(cart.attributes).length) return;

  await fetch('/cart/update.js', {
    method: "POST",
    body: JSON.stringify({
      attributes: nullHash
    }),
    // body: { items },
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
    },
  })
}

renderCustomerDraftOrders();

class EditDraftOrderButton extends HTMLElement {
  constructor() {
    super();
    this.draftOrderId = this.dataset.draftId;

    this.addEventListener('click', this.onClickHandler.bind(this));
  }

  async onClickHandler(e) {
    this.classList.add('is--loading');
    const url = `${baseUrl}/draft-order/${this.draftOrderId}?shop=${shopUrl}`;
    const draftOrder = await fetch(url)
    .then(response => response.json());

    // console.log(draftOrder);
    if(!(draftOrder && draftOrder.line_items.length > 0)) return;

    const items = draftOrder.line_items.map(line_item => {
      const item = {
        id: line_item.variant_id,
        quantity: line_item.quantity,
        properties: {
          _quote_item_ref: line_item.id,
        },
        name: line_item.name,
      };

      if(line_item?.properties && line_item?.properties?.length > 0) {
        for(let i = 0; i < line_item.properties.length; i++) {
          const { name, value } = line_item.properties[i];
          item.properties[`${name}`] = value;
        }
      }

      return item;
    });

    await clearCart();

    let listCartErrors = [];
    let requestTimout = false;
    for (let item of items) {
      let variantTitle = item.name;
      console.log("Item==>>",item);
      delete item.name;
      await fetch(theme.routes.cartAdd, {
        method: "POST",
        body: JSON.stringify({
          items: [item],
          attributes: {
            quote_ref: draftOrder.id,
            quote_num: draftOrder.name,
          },
        }),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          // check for error and list them in an array to show to the user in a popup...
          console.log("THE DATA=>>", data);
          if (data.status == 422) {
            listCartErrors.push({ ...data, name: variantTitle });
          } else if (data.status == "too_many_requests") {
            requestTimout = true;
          }
        });
    }

    const headerCartEle = document.querySelector(
      ".site-header__drawer.site-header__cart"
    );

    if (listCartErrors.length > 0) {
      let errorListHtml = listCartErrors
        .map(
          (error, i) =>
            `<div>${i + 1}. ${error.name} : ${
              error.description || "Unknown error occurred."
            }</div>`
        )
        .join("");
      document.querySelector("#cartErrorList").innerHTML = errorListHtml;

      // Show the modal
      document.querySelector("#cartErrorModal").classList.remove("hidden");
      // document.querySelector("body").classList.add("overflow-hidden");
    } else if(requestTimout == true) {
      document.querySelector("#cartErrorList").innerHTML = "Too many attempts. Please try again in a few minutes.";
      document.querySelector("#cartErrorModal").classList.remove("hidden");
      // document.querySelector("body").classList.add("overflow-hidden");
    }

    // Close button functionality
    document
      .querySelector("#cartErrorModal__close-btn")
      .addEventListener("click", closeCartErrorModal);

    document
      .querySelector("#cartErrorModal__ok-btn")
      .addEventListener("click", closeCartErrorModal);

    function closeCartErrorModal() {
      document.querySelector("#cartErrorModal").classList.add("hidden");
      // document.querySelector("body").classList.remove("overflow-hidden");
      if(requestTimout == false && listCartErrors.length != items.length) {
        headerCartEle.classList.add("site-header__cart--edit-quote");
        headerCartEle.querySelector(
          ".drawer__heading--edit-quote"
        ).innerHTML = `Edit Quote${draftOrder.name}`;
        document.dispatchEvent(new CustomEvent("ajaxProduct:added"));
      }
    }

    // commented for now...
    // await fetch(theme.routes.cartAdd, {
    //   method: "POST",
    //   body: JSON.stringify({
    //     items,
    //     attributes: {
    //       'quote_ref': draftOrder.id,
    //       'quote_num': draftOrder.name,
    //     }
    //   }),
    //   // body: { items },
    //   credentials: "same-origin",
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    // })
    // .then(response => response.json())
    // .then(data => {
    //   const headerCartEle = document.querySelector('.site-header__drawer.site-header__cart');
    //   if(data?.items?.length > 0) {
    //     headerCartEle.classList.add('site-header__cart--edit-quote');
    //     headerCartEle.querySelector('.drawer__heading--edit-quote').innerHTML = `Edit Quote${draftOrder.name}`;
    //     document.dispatchEvent(
    //       new CustomEvent("ajaxProduct:added")
    //     );
    //   } else {
    //     headerCartEle.classList.remove('site-header__cart--edit-quote');
    //   }
    // });

    if (listCartErrors?.length <= 0 && requestTimout == false) {
      headerCartEle.classList.add("site-header__cart--edit-quote");
      headerCartEle.querySelector(
        ".drawer__heading--edit-quote"
      ).innerHTML = `Edit Quote${draftOrder.name}`;
      document.dispatchEvent(new CustomEvent("ajaxProduct:added"));
    } else {
      headerCartEle.classList.remove("site-header__cart--edit-quote");
    }
    this.classList.remove("is--loading");
  }
}

customElements.define("edit-draft-order-button", EditDraftOrderButton);

(function() {
  /**
   * Save the quote back in shopify
   */
  const saveDraftOrderUpdates = document.querySelector('.btn.cart__edit-quote');
  saveDraftOrderUpdates.addEventListener('click', async () => {
    changeLoadingState(saveDraftOrderUpdates);
    
    await updateDraftOrderBackInShopify();
  
    closeAndRefreshCart();
  
    changeLoadingState(saveDraftOrderUpdates);
  });
  
  /**
   * Clear cart for new quote
   */
  const createNewQuoteButton = document.querySelector('.btn.cart__new-quote');
  console.log('createNewQuoteButton', createNewQuoteButton);
  createNewQuoteButton.addEventListener('click', async () => {
    changeLoadingState(createNewQuoteButton);
    await clearCart();
    window.location.href = '/collections/all';
  });
  
  /**
   * Save and checkout
   */
  const checkoutQuoteButton = document.querySelector('.cart__checkout-quote');
  checkoutQuoteButton.addEventListener('click', async () => {
    changeLoadingState(checkoutQuoteButton);
    const draftOrder = await updateDraftOrderBackInShopify(true);
    setTimeout(() => {
      window.location.href = `${draftOrder.invoiceUrl}`;
    }, 3000);
  });
})();


async function updateDraftOrderBackInShopify(isCheckout = false) {
  const cart = await fetch('/cart.js')
  .then(res => res.json());

  if(!(cart && cart?.attributes?.quote_ref)) return;

  const draftOrderId = cart.attributes.quote_ref;
  const url = `${baseUrl}/draft-order/${draftOrderId}?shop=${shopUrl}&checkout=${isCheckout}`;
  
  return await fetch(url, {
    method: "POST",
    body: JSON.stringify({
      ...cart
    }),
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
    },
  }).then(res => res.json());
}

async function closeAndRefreshCart() {
  await clearCart();
  // const headerCartCloseBtn = document.querySelector('#HeaderCart .site-nav__close-cart button');
  // headerCartCloseBtn.dispatchEvent(new Event('click'));
  document.dispatchEvent(
    new CustomEvent("ajaxProduct:added")
  );
}

function changeLoadingState(btn, toggleDisabled = true) {
  if(!btn) return;

  if(btn.classList.contains('btn--loading')) {
    btn.classList.remove('btn--loading');
    if(toggleDisabled) {
      btn.removeAttribute('disabled', true);
    }
  } else {
    btn.classList.add('btn--loading');
    if(toggleDisabled) {
      btn.setAttribute('disabled', true);
    }
  }
}

if(_searchFormEleQuotes) {
  const _searchFormInputEleQuotes = _searchFormEleQuotes.querySelector('input[type="search"]');
  _searchFormEleQuotes.addEventListener('submit', async (e) => {
    e.preventDefault();
    let searchInputValue = _searchFormInputEleQuotes.value;
    console.log(searchInputValue, _searchFormInputEleQuotes)

    if(searchInputValue && searchInputValue.length > 1) {
      _searchFormInputEleQuotes.classList.add('loading');
      await loadDraftOrdersTable(null, searchInputValue ?? null, true);
      _searchFormInputEleQuotes.classList.remove('loading');
    }
  });

  _searchFormInputEleQuotes.addEventListener('input', async () => {
    if(_searchFormInputEleQuotes.value.length === 0) {
      await loadDraftOrdersTable(null, null, true);
    }  
  })
}